(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-banner-3"] && !Shopify.designMode) return;
  try {
    
  if (!window.__heightsScrollToOkendoBound) {
    window.__heightsScrollToOkendoBound = true;

    const findOkendoReviews = function () {
      const selectors = [
        '[data-oke-reviews-widget]',
        '[id*="okendo_reviews_widget"]',
        '[class*="okendo_reviews_widget"]'
      ];

      for (let i = 0; i < selectors.length; i++) {
        const el = document.querySelector(selectors[i]);
        if (el) {
          const section = el.closest('.shopify-section');
          return section || el;
        }
      }

      const widgets = document.querySelectorAll('[data-oke-widget]');
      for (let i = 0; i < widgets.length; i++) {
        const widget = widgets[i];
        if (widget.hasAttribute('data-oke-star-rating')) continue;
        if (widget.hasAttribute('data-oke-badge')) continue;
        if (widget.closest('[data-oke-product-card]')) continue;
        const section = widget.closest('.shopify-section');
        return section || widget;
      }

      return null;
    };

    const smoothScrollTo = function (endY) {
      const reduceMotion =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const startY = window.pageYOffset;
      const distance = endY - startY;

      if (reduceMotion || Math.abs(distance) < 2) {
        window.scrollTo(0, endY);
        return;
      }

      const duration = 800;
      const startTime = performance.now();
      const easeInOutCubic = function (t) {
        if (t < 0.5) return 4 * t * t * t;
        return 1 - Math.pow(-2 * t + 2, 3) / 2;
      };

      const step = function (now) {
        const progress = Math.min((now - startTime) / duration, 1);
        window.scrollTo(0, startY + distance * easeInOutCubic(progress));
        if (progress < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    };

    window.heightsScrollToOkendoReviews = function () {
      const target = findOkendoReviews();
      if (!target) return;

      const headerHeight =
        parseFloat(document.documentElement.style.getPropertyValue('--header-height')) || 0;
      const extraOffset = 250;
      const endY = Math.max(
        target.getBoundingClientRect().top + window.pageYOffset - headerHeight - extraOffset,
        0
      );
      smoothScrollTo(endY);
    };

    document.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-scroll-to-okendo-reviews]');
      if (!trigger) return;
      event.preventDefault();
      window.heightsScrollToOkendoReviews();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('searchPage', () => ({
      isLoading: false,
      searchQuery: '',
      searchResult: false,
      nextPageCount: 1,
      facets_params: '',
      floatFilters: false,
      hasNextPage: false,
      init() {
        const params = new URLSearchParams(window.location.search);
        const page = params.get('page');

        this.getHasNextPage(document, page || this.nextPageCount);

        window.onpopstate = () => {
          window.location.reload();
        };
      },
      addNextPageItems(items) {
        const collectionItemsGrid = document.getElementById('coll-grid');
        items.forEach((item) => {
          collectionItemsGrid.append(item);
        });
      },
      getHasNextPage(node, counter = 1) {
        this.nextPageCount = counter;
        this.hasNextPage = !!node.querySelector('[data-next-page]');
      },
      getNewItems(response) {
        return response.querySelectorAll('#coll-grid article');
      },
      serializeForm(form) {
        let params = '';
        const elements = form.querySelectorAll('input');
        for (let i = 0; i < elements.length; ++i) {
          const element = elements[i];
          const name = element.name;
          const value = element.value;
          if (
            (value && element.checked && (name.includes('filter') || name.includes('sort_by'))) ||
            (value && name.includes('filter.v.price'))
          ) {
            params += `&${name}=${value}`;
          }
        }
        return params.substring(1);
      },
      setParams(form) {
        this.facets_params = this.serializeForm(form);
      },
      scrollToAnchor(node) {
        const anchorBlock = node;

        if (anchorBlock) {
          const elementPosition = anchorBlock.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition +
            window.pageYOffset -
            parseFloat(document.documentElement.style.getPropertyValue('--header-height') || 0);

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
        }
      },
      async clearFilter(url) {
        let params = new URLSearchParams(url.split('?')[1]);
        params.delete('q');
        params.delete('type');
        this.facets_params = params.toString();
        this.isLoading = true;
        let newURL = window.location.href + '?q=' + this.searchQuery + '&' + this.facets_params;
        this.changeUrl(newURL);
        await this.renderSearch();
        this.isLoading = false;
      },
      async setSortBy(value) {
        this.isLoading = true;
        let url = window.location;
        let params = new URLSearchParams(url.search);
        params.delete('q');
        params.delete('type');
        params.set('sort_by', value);
        this.facets_params = params.toString();
        let newURL = window.location.href + '?q=' + this.searchQuery + '&' + this.facets_params;
        this.changeUrl(newURL);
        await this.renderSearch();
        this.isLoading = false;
      },
      async applyFilters(hide = false) {
        this.isLoading = true;
        if (hide) {
          window.Alpine.store('collectionFiltersStore').hide();
        }

        await this.renderSearch();
        this.scrollToAnchor(document.getElementById('main-search'));
        this.isLoading = false;
      },
      changeUrl(url) {
        window.history.pushState({}, url, url);
      },
      async renderSearch() {
        this.isLoading = true;
        this.resultsCount = 0;

        let facets = this.facets_params;
        if (this.facets_params.length) {
          facets = '&' + this.facets_params;
        }

        const url = `/search?q=${this.searchQuery}&type=product${facets}`;
        this.changeUrl(url);

        try {
          if (!this.searchQuery.length) {
            this.searchResult = false;
            this.isLoading = false;
            return;
          }

          const currentLayout = document.getElementById(`main-search`);

          const response = await this.get(url, { responseType: 'document' });
          const newLayout = response.getElementById(`main-search`);

          if (newLayout) {
            currentLayout.outerHTML = newLayout.outerHTML;
          }

          this.searchResult = true;
          this.isLoading = false;
        } catch (e) {
          this.isLoading = false;
          console.log(e);
        }
      },
      async get(url, config = {}) {
        try {
          const options = Object.assign(
            {
              method: 'GET',
              headers: config.headers || {},
            },
            config,
          );

          const response = await fetch(url, options);

          if (!response.ok) {
            throw new Error(`Fetch error: ${response.status} ${response.statusText}`);
          }

          const text = await response.text();
          return new DOMParser().parseFromString(text, 'text/html');
        } catch (e) {
          console.log(e);
        }
      },
      async loadMore(newURL) {
        this.isLoading = true;

        try {
          const response = await this.get(newURL, { responseType: 'document' });

          const newItems = this.getNewItems(response);
          if (newItems && newItems.length) {
            this.addNextPageItems(newItems);
            this.isLoading = false;
          }

          this.getHasNextPage(response, this.nextPageCount);

          this.isLoading = false;
        } catch (e) {
          console.log(e);
          this.isLoading = false;
        }
      },
      async loadMoreProducts() {
        this.nextPageCount++;

        const newURL =
          window.location.href.split('?').shift() +
          '?q=' +
          this.searchQuery +
          '&' +
          this.facets_params +
          '&type=product&page=' +
          this.nextPageCount;
        await this.loadMore(newURL);
      },
    }));
  });

  } catch(e) { console.error(e); }
})();
})();
